// extracted by mini-css-extract-plugin
export default {"GenericIcon":"GenericIcon_GenericIcon__Bf4g8"};